import React, { Fragment } from "react";
import { Form } from "semantic-ui-react";

import LinkifiedText from "../linkified_text";
import ControlTranslationIdLabel from "../control_translation_id_label";
import { TranslationDetails } from "./translation_details";

import { getLanguageLabel, getText } from "../../helpers";

const TAGS_OPTIONS = [
  { label: "AI translation", value: "ai_translation" },
  { label: "Manual Translation", value: "manual_translation" },
  { label: "Approved", value: "approved" },
];

export default function TranslationModalContent(props) {
  const { translation, control } = props;

  const isAiTranslation = translation && translation.translation_type === "ai";
  const aiTranslation = isAiTranslation ? translation : translation && translation.ai_translation;
  const manualTranslation = !isAiTranslation ? translation : null;
  const sourceLanguangeLabel = getLanguageLabel(translation.translation_source.language);
  const resultLanguangeLabel = getLanguageLabel(translation.translation_result.language);

  return (
    <Form>
      <label>{sourceLanguangeLabel}</label>
      <Form className="translation-section">
        <TranslationDetails translation={translation.translation_source} control={control} />
      </Form>
      <br />
      <label>{resultLanguangeLabel}</label>
      <Form className="translation-section">
        <ControlTranslationIdLabel translation={translation} />
        <TranslationDetails translation={aiTranslation && aiTranslation.translation_result} control={control} />
      </Form>
      {manualTranslation && (
        <Fragment>
          <br />
          <label className="text-blue">{getText("Manual Translation Update")} - {resultLanguangeLabel}</label>
          <Form className="translation-section">
            <ControlTranslationIdLabel translation={manualTranslation} />
            <TranslationDetails translation={manualTranslation.translation_result} control={control} />
          </Form>
          <br />
          {translation.tag_list && (
            <Form.Field>
              <div className="translation-tags">
                <span className="text-light-blue">{getText("Tags")}</span>

                {translation.tag_list.map((tag) => {
                  const option = TAGS_OPTIONS.find(({ value }) => value === tag);

                  return (
                    <span className="translation-tag" key={tag}>
                      <span>{option.label}</span>
                    </span>
                  );
                })}
              </div>
            </Form.Field>
          )}
          {translation.notes && (
            <div>
              <label>{getText("Notes")}</label>
              <div className="translation-section">
                <LinkifiedText text={translation.notes} />
              </div>
            </div>
          )}
        </Fragment>
      )}
    </Form>
  );
}



// WEBPACK FOOTER //
// ./src/components/translation_modal/translation_modal_content.js